import { WHY_ITEMS } from "./marketing-content";

export function MarketingWhy() {
  return (
    <section id="why" className="container mx-auto px-4 py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Why PhiloLMS</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Designed as modern multi-tenant software, not another system you have to host and maintain
          yourself.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {WHY_ITEMS.map((item) => (
          <div key={item.title} className="p-6 rounded-lg border bg-card">
            <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
            <p className="text-muted-foreground">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
